import React, {useState, useEffect, useCallback, useRef, useMemo} from "react"
// Internal Dependancy
import ComponentWrapper from "components/HOC/ComponentWrapper"
import {get, post} from "helpers/api"
import styled from "styled-components"
import {Button} from "@uprise/button"
import {text} from "@uprise/typography"
import {Card} from "@uprise/card"
import {spacing} from "@uprise/spacing"
import {Modal} from "@uprise/modal"
import {H4, H5, H6} from "@uprise/headings"
import toast, { Toaster } from 'react-hot-toast';
import DropDown from "components/shared/DropDown"
import {useAuth0} from "@auth0/auth0-react"
export const HeaderTableContent = styled.div`
	display: flex;
`

export const CustomButton = styled(Button)`
	margin-left: 50px;
	width: 100px;
	height: 43px;
`
const FormInputContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`
const TextInput = styled.input`
	margin-left: 10px;
	margin-bottom: 0px;
	width: 60%;
	font-size: 14px;
	height: 40px;
	border-radius: 5px;
	border-width: 0.7px;
	padding-left: 10px;
	padding-right: 10px;
`
const FormLabel = styled.label``
const Checkbox = styled.input`
	margin: 0;
	padding: 0;
`
const FunctionContainer = styled.div`
	display: flex;
`
const FunctionTitleContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-itmes: center;
	width: 80%;
	margin-top: 50px;
`
const AllFunctionContainer = styled.div`
	display: flex;
	flex-direction: column;
`
const FunctionName = styled.h5`
	margin-top: 10px;
	margin-bottom: 5px;
	font-size: 16px;
`
const FunctionSubName = styled.h6`
	margin-top: 10px;
	margin-bottom: 5px;
	margin-left: 10px;
	font-weight: normal;
	font-size: 14px;
`
const CheckboxContainer = styled.div`
	margin-top: 10px;
	// margin-bottom: 5px;
`

const AssignRole = ({history}) => {
	const [coaches, setCoaches] = useState([])
	const [allRoles, setAllRoles] = useState([])
	const [selectedRoleId, setSelectedRoleId] = useState(null)
	const [selectedCoachId, setSelectedCoachId] = useState(null)

	const {getAccessTokenSilently} = useAuth0()

	const getAllUsers = async () => {
		const token = await getAccessTokenSilently()
		let response = await get(`v2/coaches?disabled=0`, {}, {Authorization: `Bearer ${token}`})
		if (response?.success) {
			const data = response.data
			console.log(data)
			setCoaches(Object.keys(data).map(item => ({label: data[item].name, value: data[item].id})))
		}
	}
	const getAllRoles = async () => {
		const modules = await get("roles")

		if (modules?.message?.length > 0) {
			const data = modules.message
			data.forEach(item => {
				item["label"] = item.roleName
				item["value"] = item.id
			})
			setAllRoles(data)
		}
	}

	useEffect(() => {
		getAllRoles()
		getAllUsers()
	}, [])

	const onRoleChange = e => {
		setSelectedRoleId(e.id)
	}
	const onCoachChange = e => {
		setSelectedCoachId(e.value)
	}

	const renderRoleDropdown = () => {
		return (
			<DropDown
				variant='primary'
				items={allRoles}
				label='Select Role'
				disabled={false}
				menuStyle={{
					width: "300px",
					position: "absolute",
					zIndex: 2
				}}
				containerStyle={{
					width: "300px",
					marginLeft: "20px",
					wordBreak: "break-all",
					position: "absolute",
					marginTop: "-15px"
				}}
				buttonStyles={{
					padding: 10,
					wordBreak: "break-all"
				}}
				isLast
				onChange={onRoleChange}
				initialSelectedItem={""}
			/>
		)
	}
	const renderUsers = () => {
		return (
			<DropDown
				variant='primary'
				items={coaches}
				label='Select user'
				disabled={false}
				menuStyle={{
					width: "300px",
					position: "absolute",
					zIndex: 2
				}}
				containerStyle={{
					width: "300px",
					marginLeft: "20px",
					wordBreak: "break-all",
					position: "absolute",
					marginTop: "-15px"
				}}
				buttonStyles={{
					padding: 10,
					wordBreak: "break-all"
				}}
				isLast
				onChange={onCoachChange}
				initialSelectedItem={""}
			/>
		)
	}
	const onSubmit = async () => {
		console.log(selectedCoachId,selectedRoleId)
		if (!selectedRoleId || !selectedCoachId || parseInt(selectedCoachId) === 0 || parseInt(selectedRoleId) === 0) {
			toast.error("Please select valid role and user")
			return
		}
		try {
			const response = await post("role/assign", {
				roleId: parseInt(selectedRoleId),
				coachId: parseInt(selectedCoachId)
			})
			console.log(response)
			if (response.code === "success") {
				toast.success("Role assigned successfully")
				history.push("/roles")
			} else {
				toast.error("Error while assigning role")
			}
		} catch (error) {
			console.log(error)
			toast.error("Error while assigning role")
		}
	}
	return (
		<ComponentWrapper menuActiveIndex={17} subMenuActiveIndex={17} headerTitle='Assign Role'>
			<Card padding={spacing.s10} backgroundColor='white'>
				{allRoles?.length > 0 && coaches?.length > 0 && (
					<>
						<FormInputContainer>
							<FormLabel>Role Name</FormLabel>
							{renderRoleDropdown()}
						</FormInputContainer>

						<FormInputContainer style={{marginTop: 40}}>
							<FormLabel>Select user</FormLabel>
							{renderUsers()}
						</FormInputContainer>

						<CustomButton
							title={"Save"}
							variant={"primary"}
							onClick={onSubmit}
							style={{marginTop: 40, marginLeft: 0}}
						/>
					</>
				)}

				<Toaster />
			</Card>
		</ComponentWrapper>
	)
}

export default AssignRole
